import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Leaf } from 'lucide-react';
export function BrandPhrase() {
  return <section className="py-14 md:py-20 bg-brand-sage-light/40" data-id="element-55">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-56">
        <FadeIn data-id="element-57">
          <Leaf className="w-6 h-6 text-brand-eucalyptus mx-auto mb-8 opacity-60" strokeWidth={1.5} data-id="element-58" />
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-relaxed text-brand-ink" data-id="element-59">
            "No vengo a decirte quién debes ser. Vengo a ayudarte a recordar
            quién eres."
          </h2>
        </FadeIn>
      </div>
    </section>;
}